export default "__VITE_ASSET__Z4Q1xRh5__"